import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import toast from "react-hot-toast";
import Navbar from "../components/Navbar";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { addTimelineEvent } from "../services/timelineService";
import { useAuth } from "../context/AuthContext";

function CaseNotes({ caseId }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { globalUser } = useAuth();
  const [caseNotes, setCaseNotes] = useState("");
  const [originalNotes, setOriginalNotes] = useState("");
  const caseData = location.state?.caseData;
  const previousPath = location.state?.from || "/";

  useEffect(() => {
    // Load existing notes from caseData if available
    // if (caseData?.caseNotes) {
    //   setCaseNotes(caseData.caseNotes);
    // } else {
    //   setCaseNotes("");
    // }

    console.log(caseId)

    const fetchNotes = async () => {
      const pendingCaseDoc = doc(db, "pending", caseId);
      const pendingCaseSnapshot = await getDoc(pendingCaseDoc);
      const disposedCaseDoc = doc(db, "disposed", caseId);
      const disposedCaseSnapshot = await getDoc(disposedCaseDoc);

      let data;
      if (pendingCaseSnapshot.exists()) {
        data = pendingCaseSnapshot.data();
      } else if (disposedCaseSnapshot.exists()) {
        data = disposedCaseSnapshot.data();
      } else {
        setError("No such case found!");
        return;
      }

      console.log(data.casenotes)
      setCaseNotes(data.casenotes)
      setOriginalNotes(data.casenotes || "")

    }

    fetchNotes()
  }, [caseData]);

  const handleSaveNotes = () => {
    if (!caseData) {
      toast.error("No case data available to save notes.");
      return;
    }

    // Save notes to local storage
    localStorage.setItem("caseNotes", caseNotes);

    // Navigate back with updated case data
    navigate(previousPath, {
      state: {
        caseData: { ...caseData, caseNotes },
        from: location.pathname,
      },
    });
    toast.success("Case notes saved successfully");
  };

  const handleSave = async () => {
    const docRef = doc(db, "pending", caseId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      await updateDoc(docRef, {
        casenotes: caseNotes
      });
      const notePreview = (text) => text ? (text.length > 80 ? text.substring(0, 80) + "..." : text) : "—";
      addTimelineEvent(caseId, "pending", {
        type: "notes_updated",
        title: "Case notes updated",
        description: "Case notes were saved",
        performedBy: globalUser?.uid || "",
        performedByName: globalUser?.name || globalUser?.displayName || "",
        changes: {
          "Notes": { old: notePreview(originalNotes), new: notePreview(caseNotes) },
        },
      });
      setOriginalNotes(caseNotes);
      toast.success("Case notes saved successfully");
    }
    else {
      const docRef = doc(db, "disposed", caseId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          casenotes: caseNotes
        });
        const notePreview = (text) => text ? (text.length > 80 ? text.substring(0, 80) + "..." : text) : "—";
        addTimelineEvent(caseId, "disposed", {
          type: "notes_updated",
          title: "Case notes updated",
          description: "Case notes were saved",
          performedBy: globalUser?.uid || "",
          performedByName: globalUser?.name || globalUser?.displayName || "",
          changes: {
            "Notes": { old: notePreview(originalNotes), new: notePreview(caseNotes) },
          },
        });
        setOriginalNotes(caseNotes);
        toast.success("Case notes saved successfully");
      }
      else {
        toast.error("No case data available to save notes.");
      }

    }


  }

  const handleBack = () => {
    navigate(previousPath, {
      state: {
        caseData,
        from: location.pathname,
      },
    });
  };

  return (
    <div className="relative">
      <div>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-gray-900">Add Case Notes</h1>
          </div>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-[#C99F4A] hover:bg-[#b88f3f] text-black text-sm font-semibold rounded-lg"
          >
            Save Note
          </button>
        </div>

        <div className="case-notes-container bg-white rounded-2xl p-4 border border-[#ECEEF5]">
          <textarea
            value={caseNotes}
            onChange={(e) => setCaseNotes(e.target.value)}
            placeholder="Write your notes here..."
            className="w-full h-56 p-2 bg-transparent text-gray-800 placeholder-gray-400 border-none outline-none resize-none"
          />
        </div>

        {originalNotes?.trim() && (
          <div className="mt-5">
            <h3 className="text-sm font-bold text-gray-900 mb-3">Saved Note</h3>
            <div className="flex items-start gap-3 bg-white border border-[#ECEEF5] rounded-xl p-4">
              <span className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center flex-shrink-0 text-sm font-bold">
                ✎
              </span>
              <p className="text-[13px] text-gray-700 whitespace-pre-wrap break-words leading-relaxed m-0">
                {originalNotes}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CaseNotes;